import config from "../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "./utils";
import type {
  LibraryGroupsGetResponse,
  LibraryGroupGetResponse,
  LibraryGroupPatchRequest,
  LibraryGroupPatchResponse,
  LibraryGroupPostRequest,
  LibraryGroupPostResponse,
} from "../../../api/src/library-groups/route";
import type { LibraryGroupRenderResponse } from "../../../api/src/library-groups/render";

export const libraryGroupsApi = createApi({
  reducerPath: "libraryGroupsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.api,
    prepareHeaders,
  }),
  tagTypes: ["libraryGroups"],
  endpoints: (builder) => ({
    getLibraryGroups: builder.query<
      LibraryGroupsGetResponse,
      string | undefined
    >({
      // todo: there's probably a better way to do query string params
      query: (stateId) => ({
        url: stateId ? `library-groups?stateId=${stateId}` : `library-groups`,
        method: "GET",
      }),
      providesTags: ["libraryGroups"],
    }),
    getLibraryGroupById: builder.query<LibraryGroupGetResponse, string>({
      query: (id) => ({ url: `library-groups/${id}`, method: "GET" }),
      providesTags: (_r, _e, id) => [{ type: "libraryGroups", id }],
    }),
    renderLibraryGroup: builder.query<
      LibraryGroupRenderResponse,
      { documentId: string; groupId: string }
    >({
      query: ({ documentId, groupId }) => ({
        url: `documents/${documentId}/library-groups/${groupId}/render`,
        method: "GET",
      }),
    }),
    createLibraryGroup: builder.mutation<
      LibraryGroupPostResponse,
      LibraryGroupPostRequest
    >({
      query: (body) => ({ url: `library-groups`, method: "POST", body }),
      invalidatesTags: ["libraryGroups"],
    }),
    updateLibraryGroup: builder.mutation<
      LibraryGroupPatchResponse,
      { id: string } & LibraryGroupPatchRequest
    >({
      query: ({ id, ...patch }) => ({
        url: `library-groups/${id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: (_r, _e, { id }) => [{ type: "libraryGroups", id }],
    }),
  }),
});

export const {
  useGetLibraryGroupsQuery,
  useGetLibraryGroupByIdQuery,
  useCreateLibraryGroupMutation,
  useUpdateLibraryGroupMutation,
  useRenderLibraryGroupQuery,
} = libraryGroupsApi;
